module.exports = __webpack_public_path__ + "img/icons8-buy-with-card copy.b8a046dc.svg";